import { createSlice } from '@reduxjs/toolkit';
import http from '../../common/cticApi';
// initial state
export const initialState = {
  loading: false,
  error: null,
  success: false,
  postOrderDetailsInfo: null,
  viewOrderDetails: null,
};
// our slice
const viewOrderSlice = createSlice({
  name: 'viewOrders',
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.success = false;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = false;
      state.success = true;
    },
    setFileDetails: (state, { payload }) => {
      if (
        state.postOrderDetailsInfo === null ||
        state.postOrderDetailsInfo?.fileID === undefined
      ) {
        let request = {
          fileID: payload.fileID,
          fileNumber: payload.fileNumber,
          dealType: payload.commercial === 0 ? 'Residential' : 'Commercial',
          fileStatus: payload.status,
        };
        state.postOrderDetailsInfo = { ...request };
      }
    },
    setEditDetails: (state, { payload }) => {
      state.viewOrderDetails = payload;
    },
  },
});

// export the actions
export const {
  setLoading,
  setError,
  setSuccess,
  setFileDetails,
  setEditDetails,
} = viewOrderSlice.actions;

export const viewOrderSliceSelector = (state) => state.viewOrders;

export const GetFileInformation = (fileID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let req = {
      FileID: fileID,
    };

    const results = await http
      .post('Order/GetFileDetails', req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setFileDetails(results.data.responseObject));
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};
export const GetOrderDetails = (FileID, UserID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      FileID: FileID,
    };

    let req = { UserID: UserID, RequestObject: request };
    const results = await http
      .post('Order/GetFileDetailsByFileIdForViewOrder', req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setEditDetails(results.data.responseObject));
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};
// export the default reducer
export default viewOrderSlice.reducer;
